module.exports = __webpack_public_path__ + "img/iconmonstr-facebook-1.7f47d1e3.svg";